import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Phase 5 (Module 16.1) — Register the PWA service worker. Skip for kiosk/visitor-pass
// routes which are explicitly out of scope per the brief.
//
// v1.2 PR-B.1 — `updateViaCache: 'none'` so the browser always re-checks the
// SW byte content on full reload. Combined with the version-bump constant in
// public/sw.js, this gives us a deterministic cache-bust on every deploy
// without users being stranded on stale chunks.
if ("serviceWorker" in navigator
    && !window.location.pathname.startsWith("/kiosk")
    && !window.location.pathname.startsWith("/visitor-pass")) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .catch(() => {});
  });
}
